import { Image } from "react-native";
import { Icons } from "../../Components";
import { Text, View } from "../../Components/Themed";
import type { AthleteProps, EventProps, LeagueProps, OrderProps, PublicPlayerProps, TeamProps, TournamentProps } from "../../types"
import React from 'react';
import OrderGradeBar from "../../MarketComponents/components/OrderGradeBar";
import { MarketComponentHelpers } from "../../MarketComponents/api";
import QRCode from "react-qr-code";
import { useColors } from "../../constants/useColors";
import moment from "moment-mini";
import ProgressTimer from "./ProgressTimer";
import { AthleteImage } from "../../Components/Jerseys";

type BetAlertProps = {
    order:OrderProps,
    league?:LeagueProps,
    team?:TeamProps,
    athlete?:AthleteProps,
    event?:EventProps,
    tournament?:TournamentProps,
    player?:PublicPlayerProps,
    color_mode?:'light'|'dark'
    
    onClose:() => void
}

const BetAlert = ({ player, order, league, team, athlete, event, tournament, color_mode, onClose }:BetAlertProps) => {
    const Colors = useColors({ mode: color_mode });
    
    return (
        <View float style={{ width:350 }}>
            <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:18, borderTopRightRadius:8, borderTopLeftRadius:8 }}>
                <Icons.BettorEdgeIcon size={18} color={Colors.text.h1} />
                <View transparent style={{ flex:1, marginLeft:20, marginRight:10 }}>
                    <Text theme='h1'>NEW BET ALERT!</Text>
                    <Text theme='description' style={{ marginTop:5 }}>@{player?.username}  {`\u2022`} {moment(order.create_datetime).fromNow()}</Text>
                </View>
                
            </View>
            <View>
            {event ?
                <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center', padding:10 }}>
                    <Image
                        source={{ uri: event?.away?.image?.url }}
                        style={{ height:40, width:40, marginRight:10 }}
                        resizeMode='cover'
                    />
                    <Text theme='h2'>{event.away?.market_name}</Text>
                    <Text theme='h1' style={{ marginRight:20, marginLeft:20 }}>VS</Text>
                    <Image
                        source={{ uri: event?.home?.image?.url }}
                        style={{ height:40, width:40, marginRight:10 }}
                        resizeMode='cover'
                    />
                    <Text theme='h2'>{event.home?.market_name}</Text>
                </View>
                :<></>}
            {tournament ?
                <View style={{ flexDirection:'row', alignItems:'center', justifyContent:'center', padding:10 }}>
                    <Text theme='h1' style={{ marginRight:20, marginLeft:20 }}>{tournament.tournament_name}</Text>
                </View>
                :<></>}
            {player ?
            <View>
                <Image
                    source={{ uri: player.profile_pic && player.profile_pic != '' ? player.profile_pic : 'https://res.cloudinary.com/hoabts6mc/image/upload/v1722453927/default_man_n96ofq.webp' }}
                    style={{ height:200, width:350 }}
                    resizeMode='cover'
                />
                
                <View type='header' style={{ flexDirection:'row', alignItems:'center', padding:10 }}>
                    {team ?
                    <Image
                        source={{ uri: team.image?.url }}
                        style={{ height:60, width:60 }}
                        resizeMode='cover'
                    />
                    :athlete ?
                    <AthleteImage
                        athlete={athlete}
                        size={40}
                        number_size={18}
                        league={league}
                    />
                    :<></>}
                    
                    <View transparent style={{ flex:1, marginLeft:10 }}>
                        <Text theme='h1'>{order.title}</Text>
                        <Text style={{ marginTop:3 }} theme='description'>{MarketComponentHelpers.getOddsLabel(order.odds)} {`\u2022`} {(order.probability * 100).toFixed(2)}%</Text>
                    </View>
                    {order.grade ?
                    <OrderGradeBar
                        grade={order.grade}
                        view_type='card'
                    />
                    :<></>}
                </View>
            </View>
            :<></>}
            
            </View>
            <View type='header' style={{alignItems:'center', padding:10}}>
                <QRCode
                    size={100}
                    value={`https://play.bettoredge.com/markets?order=${order.order_id}&type=fade`}
                />
                <Text textAlign='center' theme='h2' style={{ marginTop:4 }}>FADE ME NOW!</Text>
            </View>
            <View type='footer' style={{ borderBottomRightRadius:8, borderBottomLeftRadius:8,  }}>
                <ProgressTimer
                    onTimesUp={() => onClose()}
                    time_id={order.order_id.toString()}
                    total_time={15}
                />
            </View>
        </View>
    )
}

export default BetAlert